import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  DateField,
  ReferenceArrayField,
  Datagrid,
  ArrayField,
  FunctionField,
} from 'react-admin'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import CustomTextField from '../../components/CustomTextField'

const ProductNameField = props => {
  const { record } = props
  if (!record) return null

  if (record.bookId) {
    return (
      <CustomTextField
        {...props}
        source="bookId"
        reference="books"
        referenceField="title"
      />
    )
  }
  if (record.courseId) {
    return (
      <CustomTextField
        {...props}
        source="courseId"
        reference="courses"
        referenceField="title"
      />
    )
  }
  if (record.englishBookId) {
    return (
      <CustomTextField
        {...props}
        source="englishBookId"
        reference="english-books"
        referenceField="title"
      />
    )
  }
  if (record.ebookId) {
    return (
      <CustomTextField
        {...props}
        source="ebookId"
        reference="ebooks"
        referenceField="title"
      />
    )
  }

  return <TextField {...props} source="productName" />
}

export const SubscriptionRefundDetailShow = props => (
  <Show {...props}>
    <Box m={1}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <TextField source="id" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <TextField source="refundId" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <TextField source="subscriptionId" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <TextField source="userId" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <NumberField source="totalCreditsReceived" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <NumberField source="totalCreditsUsed" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <NumberField source="allowedCredits" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <NumberField source="overUsedCredits" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <NumberField source="publisherCommissionDeducted" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <DateField source="createdAt" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={4}>
          <SimpleShowLayout>
            <DateField source="updatedAt" />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={12}>
          <SimpleShowLayout>
            <FunctionField
              label="Inactivated Credit IDs"
              render={record =>
                record.inactivatedCreditIds
                  ? record.inactivatedCreditIds.join(', ')
                  : ''
              }
            />
          </SimpleShowLayout>
        </Grid>
      </Grid>

      <Box mt={3} p={1}>
        <Typography variant="h6">Disabled Purchase Histories</Typography>
        <ReferenceArrayField
          source="disabledPurchaseHistoryIds"
          reference="purchase-histories"
          label="">
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <TextField source="id" />
            <TextField source="category" />
            <ProductNameField label="Product Name" />
            <FunctionField
              label="Entity ID"
              render={record =>
                record.bookId ||
                record.courseId ||
                record.englishBookId ||
                record.ebookId ||
                ''
              }
            />
          </Datagrid>
        </ReferenceArrayField>
      </Box>

      <Box mt={3} p={1}>
        <Typography variant="h6">Commission Details</Typography>
        <ArrayField source="commissionDetails" label="">
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <NumberField source="amount" />
            <NumberField source="commission" />
            <TextField source="publisherId" />
            <TextField source="purchaseHistoryId" />
            <TextField source="purchaseCommissionId" />
          </Datagrid>
        </ArrayField>
      </Box>
    </Box>
  </Show>
)

export default SubscriptionRefundDetailShow
